<template>
  <div class="container">
    <div class="text--l message">
      <span class="text-bold">Hi {{firstName}},</span>
      <br><br>
      <div v-if="isReady">
        <p>Welcome to {{selfServiceAlias}}.</p>
        <p>Tell us more about what you want to buy so we can see how we can help you today.</p>
      </div>
      <div v-else-if="isInvalid">
        <p>Unfortunately we do not currently support self-service.</p>
        <p>Please contact your procurement team for any requirements you might have.</p>
      </div>
    </div>
    <div class="spacer-xl" />
    <a-btn @click="actionHandler">{{ buttonLabel }}</a-btn>
  </div>
</template>

<script>
import ABtn from "@/components/SelfService/a-btn.vue";

export default {
  components: {ABtn},
  props: ['firstName', 'selfServiceAlias', 'runnerState'],
  computed: {
    isReady() {
      return this.runnerState === 'Ready';
    },
    isInvalid() {
      return this.runnerState === 'Invalid';
    },
    buttonLabel() {
      return this.isReady ? "Let's go!" : "Thanks";
    }
  },
  methods: {
    actionHandler() {
      if (this.isReady) {
        this.$emit('start');
      } else {
        this.$emit('exit');
      }
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.message {
  text-align: center;
}
.text-bold {
  font-weight: bold;
}
.spacer-xl {
  height: 2rem;
}
</style>
